import dayjs, { Dayjs } from "dayjs";
import { DashboardDateRange } from "./types";

export const dashboardDateRangeOptions: Array<{
  value: DashboardDateRange;
  label: string;
}> = [
  { value: "thisMonth", label: "This month" },
  { value: "lastMonth", label: "Last month" },
  { value: "lastThreeMonths", label: "Last three months" },
  { value: "lastSixMonths", label: "Last six months" },
];

export const getDashboardDateRange = (
  value: DashboardDateRange,
  today: Dayjs = dayjs(),
): [string, string] => {
  let start = today.startOf("month");
  let end = today;

  if (value === "lastMonth") {
    start = today.subtract(1, "month").startOf("month");
    end = today.subtract(1, "month").endOf("month");
  }
  if (value === "lastThreeMonths") {
    start = today.subtract(2, "month").startOf("month");
  }
  if (value === "lastSixMonths") {
    start = today.subtract(5, "month").startOf("month");
  }

  return [start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
};
